import React from 'react';
import { useContext } from 'react';
import { BookContext } from '../contexts/BookContext';

const BookDetails = ({book}) => {
  const { dispatch } = useContext(BookContext);
  return ( 
    <li onClick={() => dispatch({type:'REMOVE_BOOK', id:book.id})}>
      <div className="title">{book.title}</div>
      <div className="author">{book.author}</div>
      <i class="fas fa-trash-alt"></i>

    </li>
   );
}
 
export default BookDetails;